import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export function LegalSection({ id, title, children }) {
  return (
    <section id={id} style={{ marginBottom: 26 }} data-testid={`legal-section-${id}`}>
      <h2 style={{ fontSize: 18, fontWeight: 700, color: "var(--z-teal)", margin: "0 0 10px" }}>{title}</h2>
      <div style={{ fontSize: 14.5, lineHeight: 1.7, color: "var(--z-text,#222)" }}>{children}</div>
    </section>
  );
}

export function LP({ children }) {
  return <p style={{ margin: "0 0 12px" }}>{children}</p>;
}

export default function LegalPage({ title, subtitle, updated, children, testId }) {
  return (
    <div className="z-container" style={{ maxWidth: 820 }} data-testid={testId}>
      <Link to="/" className="z-btn z-btn-ghost z-btn-sm" data-testid="legal-back-link">
        <ArrowLeft size={14} /> Accueil
      </Link>
      <h1 className="z-page-title" style={{ marginTop: 14 }}>{title}</h1>
      {subtitle && <p className="z-page-sub">{subtitle}</p>}
      {updated && (
        <p style={{ fontSize: 12.5, color: "var(--z-muted)", marginBottom: 22 }}>
          Dernière mise à jour : <strong>{updated}</strong>
        </p>
      )}
      <div className="z-card" style={{ padding: "26px 24px" }}>{children}</div>
      <div style={{ display: "flex", gap: 16, justifyContent: "center", margin: "22px 0 8px", fontSize: 13 }}>
        <Link to="/cgv" className="z-link" data-testid="legal-link-cgv">Conditions Générales</Link>
        <span style={{ color: "var(--z-border)" }}>·</span>
        <Link to="/confidentialite" className="z-link" data-testid="legal-link-privacy">Politique de confidentialité</Link>
      </div>
    </div>
  );
}
